module.exports = __webpack_public_path__ + "static/media/firefox-logo.5f09bba4.svg";